<template>
  <div v-if="shuffled.length > batchSizeDefault" v-on:mouseover="stopRotation()" v-on:mouseout="startRotation()"
       class="new-box with-overflow member-carrousel-list">
    <div>
      <h6 class="box-headline">{{ bundle.id_12565 }}</h6>
      <transition name="slide-left" mode="out-in">
        <ul class="row" v-bind:key="currentIndex">
          <li v-for="member in computedList" v-bind:key="'member' + (member ? member.id : '')" class="col-4 col-md-2">
            <a v-bind:href="member.href">
              <img v-bind:src="member.logo" v-bind:alt="member.company"/>
            </a>
          </li>
        </ul>
      </transition>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

export default {
  name: "member-carrousel-box",
  props: {
    value: {
      type: Array,
      required: true
    },
    shuffle: {
      type: Boolean,
      required: true
    }
  },
  data: function () {
    return {
      contextPath: window.contextPath,
      ready: false,
      shuffled: [],
      rotation: null,
      bundle: {
        id_12565: "Our Members"
      },
      currentIndex: 0,
      batchSizeDefault: 6
    };
  },
  created: function () {
    Vue.$bundle("portal", this.bundle, (bundle) => {
      this.bundle = bundle;
    });
    if (this.shuffle) {
      for (var i = 0; i < this.value.length; i++) {
        this.shuffled.splice(
            Math.floor(Math.random() * (this.shuffled.length + 1)),
            0,
            this.value[i]);
      }
    } else {
      for (var j = 0; j < this.value.length; j++) {
        this.shuffled.push(this.value[j]);
      }
    }
    this.startRotation();
  },
  computed: {
    computedList: function () {
      var result = [];
      for (let i = 0; i < this.batchSize; i++) {
        result.push(this.shuffled[(this.currentIndex + i) % this.shuffled.length]);
      }
      return result;
    },
    batchSize: function () {
      return xs() ? 3 : this.batchSizeDefault;
    }
  },
  methods: {
    incrementIndex() {
      this.currentIndex = (this.currentIndex + this.batchSize) % this.shuffled.length;
    },
    startRotation: function () {
      if (this.shuffled.length > 6) {
        this.rotation = setInterval(() => {
          this.incrementIndex();
        }, 6000);
      }
    },
    stopRotation: function () {
      clearInterval(this.rotation);
      this.rotation = null;
    }
  }
}
</script>

<style>
.member-carrousel-list.new-box.with-overflow {
  overflow: hidden;
  margin-bottom: 2rem;

  div {
    height: 9.5rem;
  }

  ul {
    height: 9.5rem;

    li {
      height: 9.5rem;
      padding: 0;

      a {
        border-bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        height: 7.8rem;

        img {
          margin: auto;
        }
      }
    }
  }
}
</style>